import { baseUrl } from "data/server_apis/server_api";

function isValidHttpUrl(string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
}
const addURLPrefix = (url) => {
  if (isValidHttpUrl(url)) {
    return url;
  } else {
    return `${baseUrl}${url}`;
  }
};
export default addURLPrefix;
